import { useOutletContext } from "react-router-dom";
import DashboardHeader from "../Other/DashboardHeader";
import PageHeader from "../PageHeader";
import PageContainer from "../pages/PageContainer";
import { useTranslation } from "react-i18next";

// If caller passes a plain string that matches a translation key, it will be translated.
// If caller wants to force raw text, they can pass `rawTitle` instead.
const CustomPageHeader = ({
  title,
  showPageHeader = true,
  rawTitle,
  children,
  pageContainerClass = "",
  hideBack = false,
  pageContainerInnerClass = "",
  onBack,
}) => {
  const { t } = useTranslation();
  const resolvedTitle = rawTitle ? rawTitle : t(title || "", title);
  const [sidebarToggle] = useOutletContext();
    const isMobileView = document.body.clientWidth <= 768;

  return (
    <>
{/* ✅ Only show top header if not on Home (or on desktop) */}
{!(isMobileView && window.location.pathname === "/home") && (
  <div
    className={`sm:block fixed top-0 right-0 z-50 bg-white dark:bg-black shadow-sm ${
      isMobileView ? "w-full" : "w-[calc(100vw-250px)]"
    }`}
  >
    <DashboardHeader>
      <PageHeader
        title={resolvedTitle}
        titleClassName="text-black dark:text-dark-text font-bold"
        iconClassName="text-black dark:text-dark-text"
        hideBack={hideBack}
        onBack={onBack}
      />
    </DashboardHeader>
  </div>
)}

      <PageContainer
        customClass={`max-w-4xl w-full ${pageContainerClass}`}
        childrenCustomClass={pageContainerInnerClass}
        isMobileView={isMobileView}
      >
        <div className={`sm:hidden mb-[70px] ${showPageHeader === false ? 'hidden' : ''}`}>
          <div className="fixed top-0 left-0 right-0 flex z-[11] bg-white dark:bg-dark-bg p-4 mx-auto w-full">
            <PageHeader
              title={resolvedTitle}
              className="text-black dark:text-dark-text "
              iconClassName="text-black dark:text-dark-text"
              titleClassName=""
              hideBack={hideBack}
              onBack={onBack}
            />
          </div>
        </div>
        {children}
      </PageContainer>
    </>
  );
};

export default CustomPageHeader;
